import Grid from "@mui/material/Grid";
import { delay } from "es-toolkit";
import { observer } from "mobx-react-lite";
import React from "react";
import { incrementForever, take } from "../../../util/iterators";
import { useIsSingleColumnLayout } from "../Layout/Layout2x1";
import BatchGridContainer from "./BatchGridContainer";

type LoadingListArgs = {
  onVisible: () => void;
  count: number;
  pageNumber: number;
  loading: boolean;
  placeholder: React.ReactNode;
};

function LoadingList({ onVisible, count, placeholder, pageNumber, loading }: LoadingListArgs): React.ReactNode {
  const ref = React.useRef(null);
  const isSingleColumnLayout = useIsSingleColumnLayout();
  const [intObs] = React.useState(
    new IntersectionObserver(([{ isIntersecting }]) => {
      if (isIntersecting) onVisible();
    }),
  );

  React.useEffect(() => {
    void (async () => {
      if (ref.current) intObs.unobserve(ref.current);
      await delay(100); // give React a chance to re-render
      if (ref.current && !loading) intObs.observe(ref.current);
    })();
  }, [pageNumber, loading]);

  return (
    <BatchGridContainer ref={ref} sx={{ marginTop: 0 }}>
      {[...take(incrementForever(), count)].map((i) => (
        <Grid
          key={i}
          size={{
            xs: 12,
            md: isSingleColumnLayout ? 6 : 12,
            xl: isSingleColumnLayout ? 4 : 12,
          }}
        >
          {placeholder}
        </Grid>
      ))}
    </BatchGridContainer>
  );
}

export default observer(LoadingList);
